import { createSlice } from '@reduxjs/toolkit';

const installmentSlice = createSlice({
  name: 'installment',
  initialState: {
    docs: [],
    doc:{},
    page : 1 ,
    pages : 1 , 
    docsCount : 0 , 
        createLoading : false , 


  },

  
  reducers: {
  setStats (state , action) {
            const { docs , docsCount , page , pages } = action.payload;
            state.docs = docs;
            state.docsCount = docsCount;
            state.page = page;
            state.pages = pages;
        } ,
           setCreateLoading (state , action ) {
            state.createLoading = action.payload
        } ,

    setDoc (state , action ) {
      state.doc = action.payload
    },

    updateInstallmentDoc (state, action) {
      const updated = action.payload;
      if (!updated?._id) return;
      state.docs = state.docs.map(doc => doc._id === updated._id ? { ...doc, ...updated } : doc);
    },

   
  },
});

export const { setStats,
  setCreateLoading,
  setDoc,
  updateInstallmentDoc,
} = installmentSlice.actions;
export default installmentSlice.reducer;
